<mat-chip-listbox *ngIf="statusText">
  <mat-chip [ngClass]="statusText === 'In Bearbeitung' ? 'InBearbeitung' : statusText">{{ this.statusText }}</mat-chip>
</mat-chip-listbox>
